<!-- <app-loader></app-loader> -->
<!--loader end-->
<!-- main start  -->


<div class="inn">
    <header *ngIf="router !== '/register' && router !== '/login' && router !== '/reset-password'">
        <app-header></app-header>
    </header>
    <main>
        <!-- wrapper-->
        <div id="wrapper"
            [ngStyle]="{'padding-top': router=='/register' || router == '/login' || router == '/reset-password' ? '0' : ''}">
            <!-- content-->
            <div class="content">
                <router-outlet></router-outlet>
            </div>
            <!--content end-->
        </div>
        <!-- wrapper end-->
    </main>
    <footer
        *ngIf="router !== '/register' && router !== '/login' && router !== '/reset-password' && router !== '/search' && router !== '/business'">
        <app-footer></app-footer>
    </footer>
</div>

<!--map modal open --> 
<app-map></app-map>
<!--map-modal end -->

<!--ChatGPT-->
<div class="d-none">
<app-chatgpt> </app-chatgpt>
</div>
<!--ChatGPT-->

<!--Enquiry modal open on the onclick of business-card.component -enquiry button - enquiryModalEvent()-->
<div class="modal fade" id="myEnquiryModel" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Tell us about your requirement</h5>
          <button type="button" (click)="closeEnquiryModel()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-6">
                    <app-premium-ads-slider></app-premium-ads-slider>
                </div>
                <div class="col-sm-6">
                    <div class="custom-form tabs-container">
                        <app-send-enquiry></app-send-enquiry>
                    </div>
                </div>
            </div>
        </div> 
      </div>
    </div>
</div>
<!-- Enquiry form end -->
<div id="modalBackdrop" class="modal-backdrop fade" style="display: none;"></div>

<a class="to-top"><i class="fas fa-caret-up"></i></a>
<!-- main end  -->